import NextImage from "next/image";
import ThumborJS from "thumborjs";
import Link from "next/link";
const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
const thumborKey = process.env.NEXT_PUBLIC_THUMBOR_KEY;
const thumborUrl = process.env.NEXT_PUBLIC_THUMBOR_URL;

const App = ({ content, queryParam }) => {
  const myLoader = ({ src, width }) => {
    if (src.split("?")?.length > 1) {
      return `${src}`;
    } else {
      const tugen = new ThumborJS(thumborUrl, thumborKey);
      const url = tugen
        .imgpath(src)
        .resize(width, 0)
        .filter("format(webp)")
        .genurl();

      return url;
    }
  };

  const datas = content?.length > 0 ? content[0] : content;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 justify-center">
      <div className="text-center p v-center">
        <p className="h2 title-content-sec">{`${datas?.title}`}</p>
        <p className="h5 title-sub-content-sec">{`${datas?.description}`}</p>
        <Link
          href={`${datas?.url}${queryParam ? `?${queryParam}` : ``}`}
          prefetch={false}
        >
          <button className="btn-luxury">Shop Now</button>
        </Link>
      </div>
      <div className="relative w-full aspect-[1/1]">
        <NextImage
          loader={myLoader}
          src={`${imageUrl}${datas?.image_path?.replace(/\/uploads/g, "")}`}
          alt={datas?.title}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          loading="lazy"
          placeholder="blur"
          blurDataURL={`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=`}
        />
      </div>
    </div>
  );
};

export default App;
